import React from 'react';
export const addSvg = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1.15039 6H10.8504" stroke="#565671" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 10.8499V1.1499" stroke="#565671" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}